import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!url || !publishableKey) {
  throw new Error("Faltan VITE_SUPABASE_URL y VITE_SUPABASE_PUBLISHABLE_KEY.");
}

// Ignorar invitaciones en el cliente de sesión habitual, incluso cuando
// Supabase retorna erróneamente a la Site URL en vez de /activar-cuenta.
const invitationQuery = new URLSearchParams(window.location.search);
const invitationFragment = new URLSearchParams(window.location.hash.replace(/^#/, ""));
const invitationReturn = window.location.pathname === "/activar-cuenta" ||
  (invitationFragment.get("type") === "invite" && invitationFragment.has("access_token")) ||
  (invitationQuery.get("type") === "invite" && invitationQuery.has("token_hash"));

export const supabase = createClient(url, publishableKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: !invitationReturn,
    flowType: "pkce",
  },
});

export const schema = (name: "obra" | "calidad" | "control_documental") =>
  supabase.schema(name);

export function getErrorMessage(error: unknown) {
  if (error instanceof Error) return error.message;
  if (typeof error === "object" && error && "message" in error) {
    return String((error as { message: unknown }).message);
  }
  return "Ocurrió un error inesperado.";
}
